
import { User, Mail, CheckCircle } from 'lucide-react';
import { Profile } from '@/lib/types/core/profile';
import { Button } from '@/components/ui/button';
import { Settings } from 'lucide-react';

interface ProfileHeaderProps {
  profile: Profile;
  isOwnProfile: boolean;
  onEditProfile?: () => void;
}

const ProfileHeader = ({ profile, isOwnProfile, onEditProfile }: ProfileHeaderProps) => {
  return (
    <div className="glass-card rounded-lg overflow-hidden mb-8">
      <div className="h-48 bg-gradient-to-r from-adv-charcoal to-adv-dark">
        {/* Cover image would go here in a full implementation */}
      </div>
      
      <div className="p-6 relative">
        <div className="absolute -top-16 left-6 h-32 w-32 rounded-full border-4 border-adv-dark bg-adv-darkGray flex items-center justify-center">
          {profile?.avatar_url ? (
            <img 
              src={profile.avatar_url} 
              alt={profile.username} 
              className="h-full w-full rounded-full object-cover"
            />
          ) : (
            <User size={64} className="text-adv-lightGray" />
          )}
        </div>
        
        <div className="ml-40 flex flex-col md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="text-2xl font-bold">{profile?.username}</h1>
            <div className="flex items-center gap-4 text-adv-lightGray">
              <p className="flex items-center">
                <User size={16} className="mr-1" />
                {profile?.preferred_riding_style} Rider
              </p>
              <div className="flex items-center">
                <Mail size={16} className="mr-1" />
                {profile?.email_verified ? (
                  <span className="flex items-center text-green-400">
                    <CheckCircle size={14} className="mr-1" />
                    Verified
                  </span>
                ) : (
                  <span className="text-yellow-400">Unverified</span>
                )}
              </div>
            </div>
          </div>
          
          {isOwnProfile && (
            <Button 
              className="mt-4 md:mt-0 bg-adv-darkGray hover:bg-adv-mediumGray"
              onClick={onEditProfile}
            >
              <Settings size={16} className="mr-2" />
              Edit Profile
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
